<section
  class="carousel-container"
  *ngIf="images.length > 0"
>
  <div
    fxLayout="column"
    fxLayoutAlign="center center"
    class="carousel"
  >
    <div
      class="carousel-slides-container"
      fxLayout="row"
      fxLayoutAlign="center center"
      (swipeleft)="getNext()"
      (swiperight)="getPrevious()"
    >
      <img
        *ngFor="let image of images; let i = index, trackBy: listTrackingService.disableUpdate"
        [alt]="(image.title ? image.title : '') + ' ' + (image.description ? image.description : '')"
        [src]="image.url"
        (click)="open(i, $event)"
        [ngClass]="{'current-slide': i === currentSlideNumber, 'hidden-slide': i != currentSlideNumber}"
        loading="lazy"
      >
      <button
        *ngIf="images.length > 1"
        mat-button
        (click)="getPrevious($event)"
        style="background-image: url('/assets/icons/shapes/arrows/main/left.svg')"
        class="left-arrow"
      >
      </button>
      <button
        *ngIf="images.length > 1"
        mat-button
        (click)="getNext($event)"
        style="background-image: url('/assets/icons/shapes/arrows/main/right.svg')"
        class="right-arrow"
      >
      </button>
      <ng-content>
      </ng-content>
    </div>
    <div
      #thumbnailsView
      fxLayout="row"
      fxLayoutAlign="center center"
      *ngIf="images.length > 1"
      class="carousel-thumbnails-wrapper"
    >
      <div
        #thumbnailsList
        appHoverScroll
        [direction]="'horizontal'"
        [isScrollbarHidden]="true"
        class="carousel-thumbnails"
      >
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
          [style.minWidth.px]="thumbnailsListWidth"
          class="carousel-thumbnails-container"
        >
          <div
            *ngFor="let image of images; let i = index, trackBy: listTrackingService.disableUpdate"
            [ngStyle]="{'background-image': 'url(' + (image.width_320_url ? image.width_320_url : image.url) + ')'}"
            [class.active-thumbnail]="currentSlideNumber === i"
            (click)="updateCurrentSlide(i, $event)"
            class="carousel-thumbnail-item"
          >
          </div>
        </div>
      </div>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/images-carousel-base/images-carousel-base.component.html